export default {
  eventQuizset: null,
  eventId: '',
  quizset: null
}
